type IProps = {
    donorCenter: string,
    remoteDonorCenter: string
}

const DonorCenterCell = ({ donorCenter, remoteDonorCenter }: IProps) => {
    if (!donorCenter) return <>N/A</>;

    if (remoteDonorCenter) {
        return (
            <>{donorCenter} (<span style={{ color: 'red' }}>{remoteDonorCenter}</span>)</>
        );
    };

    return (
        <>{donorCenter}</>
    );
}

export default DonorCenterCell;
